const styles = {
    avatarLogoStyle: {
        height: 0, /*dynamically set*/
        top: 0, /*dynamically set*/
    }
}

export { styles as logoAvatarStyles };


// WEBPACK FOOTER //
// ./src/js/components/LogoAvatar/styles.ts